const STRENGTH_ERRORS = {
  LENGTH : 'Your password must be between 10 - 72 characters',
  SPECIAL_CHAR: 'Your password must have at least one special character',
  MATCHES_USERNAME: 'Your password cannot be your name',
  ENTROPY: 'Your password must have at least 4 unique characters',
  MATCHES_EMAIL: 'Your password cannot be your email',
}

export const resolvePasswordErrorMessage = (error) => STRENGTH_ERRORS[error]



// WEBPACK FOOTER //
// ./src/scripts/utils/passwordUtils.js